import type { Page } from '../../types';

const criminalAction: Page[] = [
  {
    pageType: 'question',
    title: 'Criminal action',
    name: 'criminal-action-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of criminal action to declare?',
        name: 'benefits_poca_criminal_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Criminal action',
    name: 'criminal-action',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'benefits_poca_criminal_instances' },
        { title: 'Total Value', field: 'benefits_poca_criminal' },
      ],
    },
    disabled: [
      {
        field: 'benefits_poca_criminal_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'benefits_poca_criminal_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'benefits_poca_criminal',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'benefits_poca_criminal_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default criminalAction;




